import { motion } from "framer-motion";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as yup from "yup";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { contactUs } from "../../service/api";
import { toast } from "react-toastify";

const sectionOne = [
  {
    id: 1,
    title: "Grow with our real estate class",
    description:
      "We will help you to be confident enough to undertake any real estate job career. A real estate profession you can take your career to next level.",
  },
  {
    id: 2,
    title: "Become a real estate agent",
    description:
      "Nothing beats the freedom of becoming your own boss. You will have complete control over your finances and the flexibility to work as you see fit.",
  },
  {
    id: 3,
    title: "High-intensity real estate career",
    description:
      "Being a real estate agent keeps you alert. If you're willing to put in the work, the real estate industry's hustle and passion will keep you motivated.",
  },
  {
    id: 4,
    title: "Make connections",
    description:
      "Being friendly and networking are crucial aspects of becoming a real estate agent. Individuals who enjoy communication will thrive in this career.",
  },
];

const RealEstateSchool = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const successTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (successTimeoutRef.current) {
        clearTimeout(successTimeoutRef.current);
      }
    };
  }, []);

  /* FORM HANDLER */
  const sanitizePhone = (value) => value.replace(/\D+/g, "");

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      message: "For real estate license",
      type: "CONTACTUS",
    },
    validationSchema: yup.object().shape({
      name: yup.string().required("Name is required"),
      email: yup.string().email().required("Email is required"),
      phone: yup.string().required("Phone number is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      const sanitizedValues = {
        ...values,
        phone: sanitizePhone(values.phone || ""),
      };

      contactUs(sanitizedValues)
        .then((res) => {
          if (res?.status) {
            resetForm({ values: "" });
            toast.success(res?.message);
            setShowSuccess(true);
            if (successTimeoutRef.current) {
              clearTimeout(successTimeoutRef.current);
            }
            successTimeoutRef.current = setTimeout(() => {
              setShowSuccess(false);
            }, 5000);
          } else {
            resetForm({ values: "" });
            toast.error(res?.message);
          }
        })
        .catch((e) => {
          resetForm({ values: "" });
          toast.error(e?.response?.data?.message);
        });
    },
  });

  return (
    <section className="dfa-overview">
      {/* BANNER */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        variants={{
          visible: { opacity: 1 },
          hidden: { opacity: 0 },
        }}
        className="banner"
      >
        <div className="bg-dfa">
          <div className="banner-content">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-xl-6 col-sm-12">
                  <h5 className="tagline">Real Estate School</h5>
                  <h2 className="heading">
                    Join the best real estate class and courses in California
                  </h2>
                  <h5 className="subheading">
                    We understand that everyone learns differently, therefore we
                    designed a few pre-licensing real estate courses with
                    various learning styles in mind.
                  </h5>
                </div>
                <div className="col-xl-6 col-sm-12">
                  <div className="right-section">
                    <div className="contact-form">
                      <h5 className="form-title">Contact us right away!</h5>
                      {showSuccess ? (
                        <div className="mt-2 form">
                          <div className="card-box">
                            <div className="card-content">
                              <h5 className="title">
                                Thanks for reaching out!
                              </h5>
                              <p className="description">
                                We received your request and will contact you
                                shortly.
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <form
                          onSubmit={formik.handleSubmit}
                          className="mt-2 form"
                        >
                          <div className="form-group">
                            <label className="form-label">Name</label>
                            <input
                              type="text"
                              className={`form-control ${
                                formik.errors.name && formik.touched.name
                                  ? "validation-border"
                                  : ""
                              }`}
                              placeholder="Name"
                              name="name"
                              value={formik.values.name}
                              onChange={formik.handleChange}
                            />
                          </div>
                          <div className="mt-2 form-group">
                            <label className="form-label">Email address</label>
                            <input
                              type="email"
                              className={`form-control ${
                                formik.errors.email && formik.touched.email
                                  ? "validation-border"
                                  : ""
                              }`}
                              placeholder="Email address"
                              name="email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                            />
                          </div>
                          <div className="mt-2 form-group">
                            <label className="form-label">Phone</label>
                            <input
                              type="text"
                              className={`form-control ${
                                formik.errors.phone && formik.touched.phone
                                  ? "validation-border"
                                  : ""
                              }`}
                              placeholder="Phone"
                              name="phone"
                              value={formik.values.phone}
                              onChange={(event) => {
                                formik.setFieldValue(
                                  "phone",
                                  sanitizePhone(event.target.value),
                                );
                              }}
                            />
                          </div>
                          <Button type="submit" className="submit-btn">
                            Start Learning
                          </Button>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* WHY CHOOSE TO BECOME REAL ESTATE AGENT */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        variants={{
          visible: { opacity: 1 },
          hidden: { opacity: 0 },
        }}
        className="section-one"
      >
        <div className="container">
          <h2 className="heading">
            Why choose to become a real estate agent in California?
          </h2>
          <p className="subheading">
            Our real estate class offers a dynamic and intriguing career
            opportunity that requires an understanding of money, people,
            administration, marketing, public policy, and sales. You will be
            ready to start your job after passing the state test with flying
            colors. Our real estate programs will also aid you in getting placed
            at any reputed firm. In a real estate career, the annual income is
            around $62,010. This is only a starting point; once you're in the
            game, you may advance through the ranks to gain even more and lead
            the lifestyle you've always desired.
          </p>
          <div className="num-cards">
            <div className="row">
              {sectionOne.map((data, index) => {
                return (
                  <div key={index} className="col-xl-3 col-sm-12">
                    <div className="card-box">
                      <div className="number">{index + 1}</div>
                      <div className="card-content">
                        <h5 className="title">{data.title}</h5>
                        <p className="description">{data.description}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </motion.div>

      {/* CERTIFICATE SECTION */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        variants={{
          visible: { opacity: 1 },
          hidden: { opacity: 0 },
        }}
        className="section-two"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-sm-12">
              <img
                className="about-img"
                src={require("../../assets/real-estate-principles-courses.png")}
                alt="Our Real Estate Certificate Program for your career goals"
              />
            </div>
            <div className="col-xl-6 col-sm-12">
              <div className="section-two-content">
                <h2 className="heading">
                  Our Real Estate Certificate Program for your career goals
                </h2>
                <p className="subheading">
                  Our real estate class offers a dynamic and intriguing career
                  opportunity that requires an understanding of money, people,
                  administration, marketing, public policy, and sales. You will
                  be ready to start your job after passing the state test with
                  flying colors. Our real estate programs will also aid you in
                  getting placed at any reputed firm. In a real estate career,
                  the annual income is around $62,010. This is only a starting
                  point; once you're in the game, you may advance through the
                  ranks to gain even more and lead the lifestyle you've always
                  desired.
                </p>
                <p className="subheading">
                  <span>Location</span> - Cerritos, California
                </p>
                <p className="subheading">
                  <span>Courses Offered</span> - Real Estate Principles Course,
                  Real Estate Finance Course, Real Estate Practice and One-day
                  Crash Course.
                </p>
                <p className="subheading">
                  <span>Our Real Estate Certificate program</span> - We offer a
                  One-Day, In-person real estate education that can get you all
                  the knowledge you will need to pass your Real Estate Exam.
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* CTA SECTION */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        variants={{
          visible: { opacity: 1 },
          hidden: { opacity: 0 },
        }}
        className="section-three"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-8 col-sm-12">
              <h2 className="heading">Real Estate Principles Course</h2>
              <p className="subheading">
                Real Estate Principles is required by the California Department
                of Real Estate (DRE) to obtain a real estate license, an
                introductory course with primary focus on the Real Estate
                Principles and policies of the Department of Real Estate.
              </p>
            </div>
            <div className="col-xl-4 col-sm-12">
              <div className="flex-end">
                <Link to="/real-estate-principles-course">
                  <Button className="company-btn">View course details</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* REQUIREMENTS SECTION */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        variants={{
          visible: { opacity: 1 },
          hidden: { opacity: 0 },
        }}
        className="section-four"
      >
        <div className="container">
          <h2 className="heading">
            Requirements for California real estate classes (State of
            California)
          </h2>
          <div className="num-cards">
            <div className="row align-items-center">
              <div className="col-xl-4 col-sm-12">
                <div className="card-box">
                  <div className="card-content">
                    <p className="description">
                      Anyone over 18 who wishes to become a real estate agent in
                      California must complete a 40-hour real estate
                      certification program under the guidance of a competent
                      and registered trainer.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-sm-12">
                <div className="card-box">
                  <div className="card-content">
                    <p className="description">
                      In order to repeat the final exam in the state of
                      california, if a student doesn't receive a passing score
                      of 60%, they must study the course content for a minimum
                      of 18 days and should reappear for the examination.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-sm-12">
                <div className="card-box">
                  <div className="card-content">
                    <p className="description">
                      ln accordance with the California Department of Real
                      Estate's rules. The candidate must learn, comprehend, and
                      research the material for a minimum of 18 days before
                      completing the final exams.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* BEST COURSE */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        variants={{
          visible: { opacity: 1 },
          hidden: { opacity: 0 },
        }}
        className="section-five"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-sm-12">
              <div className="left-section">
                <h2 className="heading">
                  What makes us the best real estate license course in
                  California?
                </h2>
                <ul className="list">
                  <li>
                    Our real estate school provides daytime, evening, or
                    Saturday classes in the Cerritos office.
                  </li>
                  <li>
                    We have taught hundreds of students in real estate broker
                    classes who ultimately launched their individual real estate
                    companies in California or became aspirant real estate
                    agents.
                  </li>
                  <li>
                    Real estate experts with years of expertise serve as our
                    real estate license course instructors.
                  </li>
                  <li>
                    We guarantee you'll discover all that you need from our real
                    estate school for becoming a real estate agent in
                    California.
                  </li>
                  <li>
                    Our success rate is 98.7% making us dominate the California
                    offline real estate courses.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-6 col-sm-12">
              <div className="right-section">
                <div className="row align-items-center">
                  <div className="col-xl-6 col-sm-12">
                    <img
                      className="img-01"
                      src={require("../../assets/what-keeps-us-ahead-of-the-curve-01.png")}
                      alt="Our Real Estate Certificate Program for your career goals"
                    />
                  </div>
                  <div className="col-xl-6 col-sm-12">
                    <img
                      className="img-02"
                      src={require("../../assets/what-keeps-us-ahead-of-the-curve-02.png")}
                      alt="Our Real Estate Certificate Program for your career goals"
                    />
                    <img
                      className="img-03"
                      src={require("../../assets/what-keeps-us-ahead-of-the-curve-03.png")}
                      alt="Our Real Estate Certificate Program for your career goals"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* FREQUENTLY ASKED QUESTIONS */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        variants={{
          visible: { opacity: 1 },
          hidden: { opacity: 0 },
        }}
        className="section-six"
      >
        <div className="container">
          <h2 className="heading">Frequently Asked Questions</h2>
          <div className="num-cards">
            <div className="row align-items-center justify-content-center">
              <div className="col-xl-4 col-sm-12">
                <div className="card-box">
                  <div className="card-content">
                    <h5 className="title">
                      What is the average time it takes to become a real estate
                      agent?
                    </h5>
                    <p className="description">
                      While each state has its unique standards for obtaining a
                      real estate license, a residential license in California
                      needs 150 hours of prelicensing coursework.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-sm-12">
                <div className="card-box">
                  <div className="card-content">
                    <h5 className="title">
                      Is it necessary to renew my real estate license?
                    </h5>
                    <p className="description">
                      Each state has its own standards for keeping your
                      certifications current. Real estate licenses in California
                      must be renewed every four years, beginning with the date
                      on the license.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-sm-12">
                <div className="card-box">
                  <div className="card-content">
                    <h5 className="title">
                      What are the benefits of enrolling in our real estate
                      school?
                    </h5>
                    <p className="description">
                      Our real estate school offers a wide range of programs at
                      reasonable prices, and the trainers are industry experts
                      with comprehensive knowledge.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-sm-12">
                <div className="mt-3 card-box">
                  <div className="card-content">
                    <h5 className="title">
                      How much money can I make as a real estate agent?
                    </h5>
                    <p className="description">
                      Generally, real estate agents earn a commission and not a
                      fixed salary, hence the income depends purely on the
                      amount of work that you do.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-sm-12">
                <div className="mt-3 card-box">
                  <div className="card-content">
                    <h5 className="title">
                      What exactly is the distinction between a real estate
                      agent and a Realtor?
                    </h5>
                    <p className="description">
                      An agent is someone who has obtained a real estate
                      license. A realtor is a real estate professional who has
                      agreed to follow the Code of Ethics.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default RealEstateSchool;
